import { Action, type ActionOptions } from 'cadenza/action';
import type { Map } from 'cadenza/map/map';

export interface MapActionOptions extends ActionOptions {
  allowedWithSidePanel?: boolean;
}

export class MapAction extends Action {

  _map: Map;
  _allowedWithSidePanel?: boolean;

  constructor (map: Map, options: MapActionOptions) {
    super(options);
    this._map = map;
    this._allowedWithSidePanel = options?.allowedWithSidePanel;
  }

  /**
   * @protected
   * @return The map
   */
  get map () {
    return this._map;
  }

  get allowedWithSidePanel () {
    return this._allowedWithSidePanel;
  }

}
